import o from "./CdrAccordion.vue2.mjs";
import s from "./styles/CdrAccordion.module.scss.mjs";
import r from "../../../_virtual/_plugin-vue_export-helper.mjs";
const t = {
  $style: s
}, f = /* @__PURE__ */ r(o, [["__cssModules", t]]);
export {
  f as default
};
